import { useStoreConfig } from '~/store/storeConfig'

export default () => {
  const storeConfig = useStoreConfig()

  if (typeof window !== 'undefined') {
    if (window.innerWidth > 1200) {
      return storeConfig.setIsMobile(false)
    }

    if (window.innerWidth <= 1200 && window?.innerWidth > 1024) {
      return storeConfig.setIsMobile(false, true)
    }

    if (!storeConfig.getIsMobile && window?.innerWidth <= 1024) {
      return storeConfig.setIsMobile(true, false)
    }
  }
}
